/**
 * blepharoplasty.ts
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

import { registerPlugins } from '#plugins/index.js'

// Components
import BlepharoplastyVue from './views/blepharoplasty/blepharoplasty.vue'

// Composables
import { createApp } from 'vue'

// Styles
import 'unfonts.css'

import { store } from '#stores/blepharoplasty.js'

async function goApp() {
    const app = createApp(BlepharoplastyVue)
    registerPlugins(app, 'blepharoplasty')
    await store.dbinit()
    app.mount('#app')
}

goApp()
